export interface IDefferredWindow {
    navigate(ur: string): void;
}

export class IDefferredWindow {
    private static _methods: (keyof IDefferredWindow)[] = ["navigate"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            this._methods.every((value) => typeof instance[value] === "function");
    }
}

/**
 * Třída pro otevírání stránek.
 * Řeší problém Safari otevírat stránky v asynchronním volání.
 */
export class DefferredWindow implements IDefferredWindow {
    private _ref: Window | null;

    constructor() {
        this._ref = window.open();
    }
    public navigate(url: string): void {
        this._ref?.location?.assign(url);
    }
}
